<template>
  <assets-details :assets="assets" :deptList="deptList"/>
</template>

<script>
import AssetsDetails from "@/views/assets/AssetsDetails";

/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "AssetsView",
  components: {AssetsDetails},
  props: {
    assets: Object,
    deptList: Array,
  },
}
</script>
